import React from 'react';
import classNames from 'classnames';

import styles from '../styles/Review.css';
import uiStyles from  '../styles/common.css';

export default (props) => {
  return (
    <div className={styles.reviewScreen}>
      <h1 className={styles.title}>Answer Review</h1>
      <div className={styles.answerSummary}>
        <ol>
        {
          props.questions.map((q,i) => {
            const correct = q.correct == q.submission;
            const submittedClass = correct ? styles.submittedCorrect : styles.submittedWrong;

            return (
              <li key={i}>
                <p className={styles.questionText}>{q.text}</p>
                <p className={styles.answerText}>Correct Answer: <b>{q.correct}</b></p>
                <p className={submittedClass}>Submitted Answer: <b>{q.submission}{correct?' ✔':' ❌'}</b></p>
              </li>
            )
          })
        }
        </ol>
      </div>
      <a className={styles.nextBtn + ' ' + uiStyles.racerBtn} onClick={()=>props.onNextBtn()}>Next</a>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Review.js